<template>
  <popup-layout title="회원정보 수정" :is-show="isShow" width="600">
    <template v-slot:content>
      <v-row>
        <field-input title="부서" cols="6">
          <search-group
              :search-nm="modifyData.orgNm"
              :items="orgList"
              @updateData="updateData"
          />
        </field-input>
        <field-input title="직급" cols="6">
          <v-select
              v-model="modifyData.position"
              :items="positionList"
              item-text="text"
              item-value="value"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="권한" cols="6">
          <v-select
              v-model="modifyData.memberRole"
              :items="memberRoleList"
              item-text="text"
              item-value="value"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="이름" cols="6">
          <v-text-field
              v-model="modifyData.memberNm"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="연락처" cols="6">
          <v-text-field
              v-model="modifyData.telNum"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="주민등록번호" cols="6">
          <v-text-field
              v-model="modifyData.ssno"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="이메일" cols="6">
          <v-text-field
              v-model="modifyData.email"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="모집인번호" cols="6">
          <v-text-field
              v-model="modifyData.loanBrokerNo"
              outlined hide-details dense
              background-color="grey lighten-2" disabled
          />
        </field-input>
        <field-input title="사번(ID)" cols="6">
          <v-text-field
              v-model="modifyData.id"
              outlined hide-details dense
              background-color="grey lighten-2" disabled
          />
        </field-input>
        <field-input title="은행명" cols="6">
          <v-text-field
              v-model="modifyData.bankNm"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="계좌번호" cols="6">
          <v-text-field
              v-model="modifyData.bankAccount"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="본부장" cols="6">
          <v-select
            v-model="modifyData.headMgrYn"
            :items="useYnList"
            item-text="text"
            item-value="value"
            outlined hide-details dense
            background-color="white"
          />
        </field-input>
        <field-input title="관리팀장" cols="6">
          <v-select
              v-model="modifyData.managementMgrYn"
              :items="useYnList"
              item-text="text"
              item-value="value"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
        <field-input title="영업팀장" cols="6">
          <v-select
              v-model="modifyData.salesMgrYn"
              :items="useYnList"
              item-text="text"
              item-value="value"
              outlined hide-details dense
              background-color="white"
          />
        </field-input>
<!--        <field-input title="비밀번호" cols="1">-->
<!--          <v-btn class="button" outlined>초기화</v-btn>-->
<!--        </field-input>-->
      </v-row>
    </template>
    <template v-slot:button>
      <div class="buttons-layout">
        <v-btn class="button save" outlined @click="isModifyData">수정</v-btn>
        <v-btn class="button delete" outlined @click="closePopup">취소</v-btn>
      </div>
    </template>
  </popup-layout>
</template>
<script>
import PopupLayout from "@/common/layout/PopupLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import _ from "lodash";
import constant from "@/util/constant";
import {axiosInstance} from "@/util/AxiosModule";
import {mapGetters} from "vuex";
import SearchGroup from "@/common/components/SearchGroup.vue";
import func from "@/util/func";

export default {
  name: "MemberModify",
  components: {SearchGroup, FieldInput, PopupLayout},
  props: ["isShow", "memberInfo"],
  data() {
    return {
      orgList: [],
      modifyData: {},
      memberRoleList: constant.MEMBER_ROLE_LIST,
      positionList: constant.POSITION_LIST,
      useYnList: constant.YN_LIST
    }
  },
  watch: {
    isShow(value) {
      if (value) {
        this.modifyData = _.cloneDeep(this.memberInfo);
      }
    }
  },
  mounted() {
    this.setOrgList();
  },
  computed: {
    ...mapGetters("login", {
      memberRole: "memberRole",
      memberId: "memberId"
    })
  },
  methods: {
    async setOrgList() {
      this.orgList = await func.getOrgList("", "Y", "N", "");
    },
    closePopup() {
      this.modifyData = {};
      this.$emit("close");
    },
    updateData(value) {
      this.modifyData.orgCd = value.id;
    },
    isModifyData() {
      this.showConfirm({
        message: "수정한 정보를 저장하시겠습니까?",
        successCallback: () => {
          this.modify();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async modify() {
      try {
        let memberDto = {};
        memberDto = this.modifyData;
        memberDto["updateId"] = this.memberId;
        await axiosInstance.patch("/admin/member", memberDto)
            .then(() => {
              this.showAlert({
                message: "수정 완료되었습니다",
                successCallback: () => {
                  this.$emit("close");
                  this.$emit("refresh");
                }
              })

            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-layout {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>